import Vue from 'vue';
import { gsap } from 'gsap';
import { SplitText } from '../gsap-bonus/SplitText';

Vue.component('text-split-component', {
    props: {
        item: {
            type: Object,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            splitLines: '',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('window-resize', this.revert);
        this.split();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        split() {
            const titleElement = this.$el.querySelector('.project__title');
            this.splitLines = new SplitText(titleElement, {
                type: 'lines',
                linesClass: 'line',
            });
        },

        revert() {
            if (this.splitLines) {
                this.splitLines.revert();
            }
        },
    },

    beforeDestroy() {
        console.log('Destroying');
        this.revert();
        EventBus.$on('window-resize', this.revert);
    },
});
